import Activity from ".";

export const activityRoutes = () => [
  {
    path: "/admin/activity",
    title: "activity",
    layout: "admin",
    routeType: "admin",
    component: Activity,
  },
];
